import { render } from "./FullReportTable.vue?vue&type=template&id=9774fe4c"
import script from "./FullReportTable.vue?vue&type=script&lang=js"
export * from "./FullReportTable.vue?vue&type=script&lang=js"

import "./FullReportTable.vue?vue&type=style&index=0&id=9774fe4c&lang=css"
script.render = render

export default script